import { useFormDataQuery } from '@/api/getters';
import AfterDoc from '@/components/ui/AfterDoc';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const CheckDocuments = () => {
  const { i18n } = useLingui();
  const { data } = useFormDataQuery();

  return (
    <AfterDoc
      withButton
      consultant={CONSULTANTS.EWELINA_ASSISTANT}
      title={i18n.t('Dokumenty podpisane')}
      thankYouMessage={i18n.t(
        `Sprawdzimy teraz podpisane pełnomocnictwa i oświadczenia. Po zakończeniu wygenerujemy umowę do pobrania.`
      )}
    >
      <div className="flex flex-col gap-2 lg:gap-4">
        <p className="body">{i18n.t('Prześlemy ją do Ciebie na adres:')}</p>
        <div className="rounded-xl bg-gray-100 px-2.5 py-5 text-center">
          <p className="h5 lg:text-[18px] lg:leading-7">{data?.user.email}</p>
        </div>
      </div>
      <p className="body">
        {i18n.t(
          'Jeśli masz pytania, jesteśmy do Twojej dyspozycji. To wszystko na dziś, możesz zamknąć panel.'
        )}
      </p>
    </AfterDoc>
  );
};

export default CheckDocuments;
